import { render, staticRenderFns } from "./LoginAuthenticator.vue?vue&type=template&id=50fae014&scoped=true&"
import script from "./LoginAuthenticator.vue?vue&type=script&lang=js&"
export * from "./LoginAuthenticator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fae014",
  null
  
)

export default component.exports